export const getXPostUrl = (username: string, postId: string) => {
  return `https://x.com/${username}/status/${postId}`;
};

export const getXUserLink = (username: string) => {
  return (
    <a
      href={`https://x.com/${username}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-x-blue hover:underline"
    >
      @{username}
    </a>
  );
};

export const CEDE_HUB_USERNAME = "cedehub";
